var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{ref:"calendar",attrs:{"id":"fullCalendar"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }